import React from "react";
import { Link } from "react-router-dom";

const Service = ({ serviceData }) => {
  const { id, attributes } = serviceData;
  const { address, companyName, listImage, serviceType } = attributes;
  const apiBase = process.env.REACT_APP_BASE_URL || "";
  const imgUrl = listImage?.data?.attributes?.url;
  const typeName = serviceType?.data?.attributes?.name || "Service";
  const cityName = address?.city?.data?.attributes?.name;
  const street = address?.street;

  return (
    <article className="hn-card hn-card-service">
      <div className="hn-card-thumb" style={{ position: "relative" }}>
        <Link to={`/services/${id}`}>
          <img
            src={imgUrl ? `${apiBase}${imgUrl}` : "https://via.placeholder.com/400x250?text=Service"}
            alt={companyName}
            loading="lazy"
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
        </Link>
        <span className="hn-card-badge">{typeName}</span>
      </div>
      <div className="hn-card-body">
        <div className="hn-card-meta">
          {cityName && <span><i className="bi bi-pin-map" /> {cityName}{street ? `, ${street}` : ""}</span>}
        </div>
        <h3 className="hn-card-title">
          <Link to={`/services/${id}`}>
            {companyName}
          </Link>
        </h3>
        <Link to={`/services/${id}`} className="hn-card-cta">
          View details <i className="bi bi-arrow-right" />
        </Link>
      </div>
    </article>
  );
};

export default Service;
